let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gfjfP")).then(() => parcelRequire('7C5UV'));